import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcAddFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.25 19a1.75 1.75 0 1 0 3.5 0v-5.25H19a1.75 1.75 0 1 0 0-3.5h-5.25V5a1.75 1.75 0 1 0-3.5 0v5.25H5a1.75 1.75 0 1 0 0 3.5h5.25z"
  }));
}
var IcAddFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcAddFill));

export { IcAddFill as I };
